(() => {
  'use strict';
  if (window.__SQ_EXPANDED_UNIVERSAL_STABILITY_V16__) return;
  window.__SQ_EXPANDED_UNIVERSAL_STABILITY_V16__ = true;

  const MODAL = '[data-lcs-favorite-expanded],[data-lcs-expanded-modal],.lcs-favorite-expanded';
  const HOST = '[data-lcs-expanded-controller],[data-lcs-favorites-page]';
  const CLOSE = '[data-lcs-expanded-close],.lcs-favorite-expanded__close,.lcs-favorite-expanded__overlay';
  const SIZE = `${MODAL} .lcs-selected-size`;
  const CLOSE_GUARD_MS = 450;
  const closing = () => Date.now() < Number(window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ || 0);

  const stopCartHandoffDuringClose = (event) => {
    if (!closing()) return;
    event.preventDefault?.();
    event.stopPropagation?.();
    event.stopImmediatePropagation?.();
  };
  document.addEventListener('sq:cart:handoff', stopCartHandoffDuringClose, true);
  window.addEventListener('sq:cart:handoff', stopCartHandoffDuringClose, true);

  const compactSize = (value) => {
    const full = String(value || 'Size').trim();
    if (/^one\s*size$/i.test(full)) return { full, short: 'ONE SZ' };
    const short = Array.from(full).slice(0, 6).join('');
    return { full, short: short || 'Size' };
  };

  const normalizeSize = (element) => {
    if (!(element instanceof HTMLElement)) return;
    const raw = (
      element.dataset.sqFullSize ||
      element.getAttribute('title') ||
      element.textContent ||
      ''
    ).trim();
    const { full, short } = compactSize(raw);
    element.dataset.sqFullSize = full;
    element.textContent = short;
    element.setAttribute('aria-label', full);
    if (full !== short) element.title = full;
    else element.removeAttribute('title');
  };

  const normalizeSizes = (scope = document) => {
    if (scope instanceof Element && scope.matches(SIZE)) normalizeSize(scope);
    scope.querySelectorAll?.(SIZE).forEach(normalizeSize);
  };

  const patchController = (controller) => {
    if (!controller || controller.__sqUniversalStabilityV16) return;
    controller.__sqUniversalStabilityV16 = true;
    const originalRenderSelections = controller.renderSelections?.bind(controller);
    if (originalRenderSelections) {
      controller.renderSelections = function universalRenderSelections() {
        const result = originalRenderSelections();
        normalizeSizes(this.section || document);
        return result;
      };
    }
  };

  const patchControllers = (scope = document) => {
    const hosts = [];
    if (scope instanceof Element && scope.matches(HOST)) hosts.push(scope);
    scope.querySelectorAll?.(HOST).forEach((host) => hosts.push(host));
    hosts.forEach((host) => patchController(host.__lcsFavoritesPage));
    patchController(window.LCSFavoriteExpanded);
  };

  const style = document.createElement('style');
  style.id = 'sq-expanded-universal-stability-v16-css';
  style.textContent = `
    html body :is(${MODAL}) .pick-quick-option__pill--visual .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:hover .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:focus .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:focus-visible .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:focus-within .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:active .pick-quick-option__text,
    html body :is(${MODAL}) .pick-quick-option__pill--visual input:checked ~ .pick-quick-option__text {
      outline:0!important;
      border:0!important;
      border-color:transparent!important;
      border-radius:0!important;
      background:transparent!important;
      box-shadow:none!important;
      text-shadow:none!important;
      -webkit-text-stroke:0!important;
      -webkit-text-fill-color:#111!important;
      filter:none!important;
    }
    html body :is(${MODAL}) .pick-quick-option__pill--visual:hover .pick-quick-option__swatch,
    html body :is(${MODAL}) .pick-quick-option__pill--visual:focus-within .pick-quick-option__swatch,
    html body :is(${MODAL}) .pick-quick-option__pill--visual input:checked ~ .pick-quick-option__swatch {
      outline:0!important;
      border-color:rgba(17,17,17,.18)!important;
      box-shadow:none!important;
    }
    html body :is(${MODAL}) .lcs-selected-variant-line {
      grid-template-columns:24px minmax(0,1fr)!important;
      column-gap:8px!important;
      padding-inline:0 2px!important;
    }
    html body :is(${MODAL}) .lcs-selected-color {
      width:24px!important;
      min-width:24px!important;
      max-width:24px!important;
      overflow:hidden!important;
      -webkit-text-stroke:0!important;
      text-shadow:none!important;
    }
    html body :is(${MODAL}) .lcs-selected-size {
      width:auto!important;
      min-width:0!important;
      max-width:6.4ch!important;
      justify-self:center!important;
      overflow:hidden!important;
      text-overflow:clip!important;
      white-space:nowrap!important;
      -webkit-text-stroke:0!important;
      text-shadow:none!important;
      contain:inline-size!important;
    }
  `;
  document.getElementById('sq-expanded-universal-stability-v15-css')?.remove();
  document.getElementById(style.id)?.remove();
  document.head.appendChild(style);

  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const close = target?.closest(CLOSE);
    if (!close?.closest(MODAL)) return;
    window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ = Date.now() + CLOSE_GUARD_MS;
    window.__SQ_EXPANDED_POINTER_CLOSE_UNTIL__ = Date.now() + CLOSE_GUARD_MS;
  }, true);

  const start = () => {
    patchControllers(document);
    normalizeSizes(document);
    new MutationObserver((records) => {
      let shouldPatch = false;
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(HOST) || node.querySelector?.(HOST)) shouldPatch = true;
          normalizeSizes(node);
        }
      }
      if (shouldPatch) patchControllers(document);
    }).observe(document.body, { childList: true, subtree: true });
    [80, 260].forEach((delay) => setTimeout(() => {
      patchControllers(document);
      normalizeSizes(document);
    }, delay));
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
  document.addEventListener('shopify:section:load', (event) => {
    patchControllers(event.target);
    normalizeSizes(event.target);
  });
})();
